
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Download, List, PhoneCall, Voicemail, PhoneMissed } from 'lucide-react';

interface CallHistoryFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  filterOutcome: string;
  onFilterChange: (filter: string) => void;
  onExport: () => void;
}

export const CallHistoryFilters = ({
  searchQuery,
  onSearchChange,
  filterOutcome,
  onFilterChange,
  onExport
}: CallHistoryFiltersProps) => {
  return (
    <div className="space-y-3">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search by number or name..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      
      <div className="flex gap-2 flex-wrap">
        <Button
          variant={filterOutcome === 'all' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onFilterChange('all')}
          className="w-10 h-10 p-0"
          title="All calls"
        >
          <List className="h-4 w-4" />
        </Button>
        <Button
          variant={filterOutcome === 'connected' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onFilterChange('connected')}
          className="w-10 h-10 p-0"
          title="Connected calls"
        >
          <PhoneCall className="h-4 w-4" />
        </Button>
        <Button
          variant={filterOutcome === 'voicemail' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onFilterChange('voicemail')}
          className="w-10 h-10 p-0"
          title="Voicemail calls"
        >
          <Voicemail className="h-4 w-4" />
        </Button>
        <Button
          variant={filterOutcome === 'busy' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onFilterChange('busy')}
          className="w-10 h-10 p-0"
          title="Busy calls"
        >
          <PhoneMissed className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onExport}
          className="w-10 h-10 p-0"
          title="Export call history"
        >
          <Download className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
